import axios from '../utils/axios';

export default function fetchTags(adminId, recruiterId, params) {
    return (
        axios.get('/admin/' + adminId + '/recruiter/' + recruiterId + '/tags', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
